import React from "react";
import { ContentView, ContentProduct, ProductProps } from "../../../../content/components";
import { ResizeMode, ViewType } from "../../../knobs/types";

export const ProductGridItem = React.memo((
    props: {
        viewsHeight: number,
        showCaption: boolean,
        showShadow?: boolean,
        showTextBackground: boolean,
        viewsMargins: number,
        colNumber: number,
        borderRadius: number
    } & ProductProps
) => {
    return (
        <ContentView style={{
            height: props.viewsHeight,
            marginRight: props.colNumber === 0 ? props.viewsMargins / 2 : undefined,
            marginLeft: props.colNumber === 1 ? props.viewsMargins / 2 : undefined,
            marginBottom: props.viewsMargins,
            borderRadius: props.borderRadius,
            shadowOpacity: props.showShadow ? 0.5 : undefined,
            shadowRadius: props.showShadow ? 6 : undefined,
            overflow: 'hidden'
        }}>
            <ContentProduct
                id={props.id}
                viewType={ViewType.Grid}
                caption={''}
                textColor={props.textColor}
                textAlign={props.textAlign}
                showCaption={props.showCaption}
                placeholderImage={props.placeholderImage}
                showTextBackground={props.showTextBackground}
                fontWeight={props.fontWeight}
                imageResizeMode={props.imageResizeMode as ResizeMode}
                blurIntencity={props.blurIntencity}
                showPrice={props.showPrice}
            />
        </ContentView>
    );
})